import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const DyanmicDataList = ({
  columns,
  data,
  onFilter,
  filteredData,
  globalFilter,
}) => {
  return (
    <DataTable
      value={data}
      // onFilter={onFilter}
      // filteredValue={filteredData}
      paginator
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      rows={10}
      rowsPerPageOptions={[5, 10, 25]}
      className="main-table table-td"
      scrollable
      scrollHeight="calc(100vh - 268px)"
      responsiveLayout="scroll"
      globalFilter={globalFilter}
    >
      {columns?.map((col, indx) => (
        <Column
          key={indx}
          field={col?.field}
          header={col?.header}
          body={col.body}
          fitler
          filterMatchMode="contains"
          sortable
        />
      ))}
    </DataTable>
  );
};

export default DyanmicDataList;
